import { fixString } from "@monta/router-js";
import type { AnchorHTMLAttributes } from "react";
import type { IMenu } from "../../../../constants";
import { applicationTypeIdEnum, ExceptionTypeIDEnum } from "../../../../constants";

export const generatPropsTagA = (
  menuItem: IMenu,
  onClickWithoutHref?: () => void,
  onClickrelative?: () => void,
): Partial<
  Pick<
    AnchorHTMLAttributes<HTMLAnchorElement>,
    "onClick" | "id" | "target" | "rel" | "href"
  >
> => {
  let propsTagA = {};
  switch (menuItem.applicationTypeID) {
    case applicationTypeIdEnum.GWT:
      propsTagA = {
        href: fixString(
          `/#${
            menuItem?.exceptionTypeID === ExceptionTypeIDEnum.KONKOR_SIMULATOR
              ? "!oldPopup;a144=konkor"
              : menuItem?.applicationUrl
          }`,
          "GWT_URL",
        ),
        rel: "noreferrer",
      };
      break;
    case applicationTypeIdEnum.LANDING:
      propsTagA = {
        href: fixString((menuItem?.applicationUrl || "") + "/", "LANDING_URL"),
        onClick: onClickrelative,
      };
      break;
    case applicationTypeIdEnum.PANEL:
      propsTagA = {
        href: fixString(menuItem?.applicationUrl || "", "PANEL_URL"),
      };
      break;
    case applicationTypeIdEnum.APPLICATION:
      propsTagA = {
        href: fixString(menuItem?.applicationUrl || "", "APPLICATION_URL"),
      };
      break;
    case applicationTypeIdEnum.EXTERNAL:
      propsTagA = {
        href: menuItem?.applicationUrl,
      };
      break;
    case applicationTypeIdEnum.LEGACY_APPLICATION:
      propsTagA = {
        href: fixString(
          menuItem?.applicationUrl || "",
          "LEGACY_APPLICATION_URL",
        ),
      };
      break;
    default:
      propsTagA = {
        href: "",
        onClick: onClickWithoutHref,
      };
      break;
  }

  return { ...propsTagA, id: `menu-item-${menuItem?.linkID}` };
};
